import kamala from '../../kamala'
import Tabs from './Tabs'
import TabPane from './TabPane'

const KTabsFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
  },
  KTabs: Tabs,
  KTabPane: TabPane,
}

export { Tabs, TabPane }

export default KTabsFamily
